import CheckIcon from '@images/icons/check-activity.svg?react'
import ExpenseRejectedIcon from '@images/icons/expense-reject.svg?react'
import ExpenseEditedIcon from '@images/icons/expense-return.svg?react'
import ExpenseSkippedIcon from '@images/icons/expense-skipped.svg?react'
import ExpenseSubmittedIcon from '@images/icons/expense-submitted.svg?react'
import cn from 'classnames'
import ReactTooltip from 'react-tooltip'
import { extractInitials, preparedTooltip } from './UserInitials.helper'

import './userInitials.scss'

type UserInitialsProps = {
  user?: any
  users?: any
  label?: string
  className?: string
  approverAction?: string
  isSubmitted?: boolean
  skipped?: boolean
}

const UserInitials = (props: UserInitialsProps) => {
  const { user, users, className, label, approverAction, isSubmitted, skipped } = props

  return (
    <div>
      <div
        className={cn('user-initials', className, { skipped })}
        data-for='user-info-tooltip'
        data-tip={preparedTooltip(user ? [user] : users)}
      >
        {label ? label : extractInitials(user)}

        {isSubmitted && (
          <div className='success-icon'>
            <ExpenseSubmittedIcon width={16} height={16} />
          </div>
        )}

        {approverAction === 'APPROVE' && (
          <div className='success-icon'>
            <CheckIcon width={16} height={16} />
          </div>
        )}

        {approverAction === 'REJECT' && (
          <div className='success-icon'>
            <ExpenseRejectedIcon width={16} height={16} />
          </div>
        )}

        {approverAction === 'SKIPPED' && (
          <div className='success-icon'>
            <ExpenseSkippedIcon width={16} height={16} />
          </div>
        )}

        {approverAction === 'EDIT' && (
          <div className='success-icon'>
            <ExpenseEditedIcon width={16} height={16} />
          </div>
        )}
      </div>

      <ReactTooltip
        id='user-info-tooltip'
        place='bottom'
        html
        type='dark'
        className='user-info-tooltip'
        padding='12px'
      />
    </div>
  )
}

export default UserInitials
